/**
 * Singleton empty array and object so we don't create new ones in mapper and
 * render methods.
 */
// @ts-expect-error - TS4104 - The type 'readonly []' is 'readonly' and cannot be assigned to the mutable type '[]'.
export const emptyArray: [] = Object.freeze([]);
// @ts-expect-error TS2304
export const emptyObject: $TEMPORARY$Object$freeze<Record<any, any>> =
  Object.freeze({});
